'use strict';

// catch any global unhandled promise rejections
window.onunhandledrejection = function (_ref) {
    var reason = _ref.reason;

    console.error('Unhandled promise rejection', reason.stack);
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/utils/log-uncaught-promises.js
 ** module id = 347
 ** module chunks = 0
 **/